"use strict";
'use strict';

function interopDefault(mod) {
  return mod.default || mod;
}

exports.interopDefault = interopDefault;
